import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './course.actions';
import {
	ClearingCourse,
	Course,
	UniversityClearingCourse,
	UniversityCourse,
} from '../../models/course.models';

export const _STATE_COURSE_FEATURE_KEY = 'stateCourse';

export interface State {
	course: Course | null;
	clearingCourse: ClearingCourse | null;
	university: UniversityCourse | null;
	clearingUniversity: UniversityClearingCourse | null;
	isCourseLoading: boolean;
	isUniLoading: boolean;
	error?: any;
}

export interface StateCoursePartialState {
	readonly [_STATE_COURSE_FEATURE_KEY]: State;
}

export const initialState: State = {
	course: null,
	clearingCourse: null,
	university: null,
	clearingUniversity: null,
	isCourseLoading: false,
	isUniLoading: false,
};

const stateCourseReducer = createReducer(
	initialState,
	on(actions.fetchCourse, (state) => ({
		...state,
		isCourseLoading: true,
		error: null,
	})),
	on(actions.updateCourse, (state, { course }) => ({
		...state,
		course: course,
		isCourseLoading: course ? false : true,
	})),
	on(actions.fetchUniversity, (state) => ({
		...state,
		isUniLoading: true,
		error: null,
	})),
	on(actions.updateUniversity, (state, { university }) => ({
		...state,
		university: university,
		isUniLoading: false,
	})),
	on(actions.fetchClearingCourse, (state) => ({
		...state,
		isCourseLoading: true,
		error: null,
	})),
	on(actions.updateClearingCourse, (state, stateClearingCourse) => ({
		...state,
		clearingCourse: stateClearingCourse.clearingCourse,
		isCourseLoading: false,
	})),
	on(actions.fetchClearingUniversity, (state) => ({
		...state,
		isUniLoading: true,
		error: null,
	})),
	on(actions.updateClearingUniversity, (state, stateClearingUniversity) => ({
		...state,
		clearingUniversity: stateClearingUniversity.clearingUniversity,
		isUniLoading: false,
	})),
	on(actions.loadStateCourseFailure, (state, error) => ({
		...state,
		isCourseLoading: false,
		isUniLoading: false,
		error,
	})),
);

export function reducer(state: State | undefined, action: Action) {
	return stateCourseReducer(state, action);
}
